import React from 'react';
import PropTypes from 'prop-types';

const LinkIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14">
        <g fill={fill}>
            <path d="M12.907 1.092a3.734 3.734 0 00-5.28 0L5.544 3.174a4.616 4.616 0 01.5-.026 4.821 4.821 0 011.525.245l1.18-1.18a2.146 2.146 0 013.036 3.035l-2.31 2.31a2.149 2.149 0 01-3.493-.675 1.064 1.064 0 00-.7.312l-.615.616a3.735 3.735 0 005.928.87l2.31-2.311a3.734 3.734 0 00.002-5.278z" />
            <path d="M7.982 10.849a4.788 4.788 0 01-1.542-.254L5.251 11.78a2.146 2.146 0 01-3.035-3.036l2.31-2.31a2.149 2.149 0 013.494.676 1.061 1.061 0 00.7-.312l.614-.615a3.736 3.736 0 00-5.928-.871L1.093 7.627a3.733 3.733 0 005.279 5.28l2.08-2.08a5.227 5.227 0 01-.47.022z" />
        </g>
    </svg>
);

LinkIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

LinkIcon.defaultProps = {
    width: '14',
    height: '14',
    fill: '#999'
};

export default LinkIcon;
